import React, { useRef } from "react";

const AnimatedButton = ({ className = "", children, onClick, href, target, rel, type = "button", ...rest }) => {
  const ref = useRef(null);

  const handleClick = (e) => {
    const el = ref.current;
    if (el) {
      const rect = el.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const ripple = document.createElement("span");
      ripple.className = "ripple";
      const size = Math.max(rect.width, rect.height) * 2;
      ripple.style.width = size + "px";
      ripple.style.height = size + "px";
      ripple.style.left = x + "px";
      ripple.style.top = y + "px";
      el.appendChild(ripple);
      setTimeout(() => { ripple && ripple.remove(); }, 650);
    }
    if (onClick) onClick(e);
  };

  const classes = ["btn", className].filter(Boolean).join(" ");

  if (href) {
    return (
      <a ref={ref} className={classes} href={href} target={target} rel={rel} onClick={handleClick} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <button ref={ref} type={type} className={classes} onClick={handleClick} {...rest}>
      {children}
    </button>
  );
};

export default AnimatedButton;